import dayjs from "./dayjs-util";

// Note to a future dev:
// IMPORTANT ///////////////////////////////////////////////////////////////////
// UTC is used for storage, querying, and internal chart timestamps. 
// Melbourne time is used only when interpreting a selected calendar day and rendering text to the user.
////////////////////////////////////////////////////////////////////////////////


export const getTimeFormat = (timeValue, period, overridePeriod = null, isFullMonth = false) => {
    
    const localPeriod = (overridePeriod === null ? period.toLowerCase(): overridePeriod.toLowerCase());
    const dateFormat = isFullMonth ? "DD MMMM" : "DD MMM";
    switch (localPeriod) {
        case "daily":
            return dayjs.unix(timeValue).tz('Australia/Melbourne').format(dateFormat);
        case "hourly":
            return dayjs.unix(timeValue).tz('Australia/Melbourne').format('hh A');
        case "datetime":
            return dayjs.unix(timeValue).tz('Australia/Melbourne').format('DD MMM | hh A');
        default:
            return dayjs.unix(timeValue).format("DD MMM");
    }
};

export const getAESTStartTime = (selectedDate) => {
    return dayjs.unix(selectedDate).tz("Australia/Melbourne").startOf("day");
}

export const getAESTEndTime = (selectedDate) => {
    return dayjs.unix(selectedDate).tz("Australia/Melbourne").endOf("day");
}